export const getFiles = (state) => state.files
